import { X } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import FinalConsent from '../../../../../../components/signup/customers/FinalConsent';
import { Application } from '../../../../../../types/dbTypes';
import { ApplicationStep, Entity } from '../../../../../../types/apiTypes';

interface FinalConsentModalProps {
  isOpen: boolean;
  onClose: () => void;
  application_id: string;
  application: Application;
  userId: string;
}

function FinalConsentModal({
  isOpen,
  onClose,
  application_id,
  application,
  userId,
}: FinalConsentModalProps) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleClose = () => {
    onClose();
    navigate('/dashboard/home');
  };

  const handleSetStep = (step: string) => {
    // When step changes, close the modal and refresh
    if (step !== ApplicationStep.FinalConsent) {
      onClose();
      navigate('/dashboard/home');
    }
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="relative h-full w-full bg-white">
        {/* Close Button */}
        <button
          onClick={handleClose}
          className="absolute left-6 top-6 z-[210] flex h-10 w-10 items-center justify-center rounded-full bg-white text-gray-600 shadow-lg transition-all hover:bg-gray-100 hover:text-gray-900"
          aria-label="Close and return to dashboard"
        >
          <X size={24} weight="bold" />
        </button>

        {/* Final Consent Component */}
        <div className="h-full w-full overflow-y-auto">
          <FinalConsent
            currStep={ApplicationStep.FinalConsent}
            selectedRole={Entity.Customer}
            setStep={handleSetStep}
            application_id={application_id}
            application={application}
          />
        </div>
      </div>
    </div>
  );
}

export default FinalConsentModal;
